export default __webpack_public_path__ + "static/media/isBusinessUser.de2c8f7d.svg";